<template>
    <div class="page-block__item-wrapper">
        <div class="page-block__item">
            <form @submit.prevent="createUser" class="u-full-width">
                <div class="layout">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.first_name"
                            :error="form.errors.first('first_name')"
                            :label="trans('customer.first_name')"
                            name="first_name"
                            class="u-full-width"
                            required
                            focus
                        />
                    </div>
                    <!---->
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.last_name"
                            :error="form.errors.first('last_name')"
                            :label="trans('customer.last_name')"
                            name="last_name"
                            class="u-full-width"
                            required
                        />
                    </div>
                </div>
                <div class="layout">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.organization"
                            :error="form.errors.first('organization')"
                            :label="trans('customer.organization')"
                            name="organization"
                            class="u-full-width"
                        />
                    </div>
                    <!---->
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.department"
                            :error="form.errors.first('department')"
                            :label="trans('customer.department')"
                            name="department"
                            class="u-full-width"
                        />
                    </div>
                </div>
                <div class="layout">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.email"
                            :error="form.errors.first('email')"
                            :label="trans('customer.email')"
                            name="email"
                            class="u-full-width"
                            required
                            type="email"
                        />
                    </div>
                    <!---->
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.phone_number"
                            :error="form.errors.first('phone_number')"
                            :label="trans('customer.phone_number')"
                            name="phone_number"
                            class="u-full-width"
                            required
                        />
                    </div>
                </div>
                <div class="layout">
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.street_name"
                            :error="form.errors.first('street_name')"
                            :label="trans('customer.street_name')"
                            name="street_name"
                            class="u-full-width"
                            required
                        />
                    </div>
                    <!---->
                    <div class="layout__item u-1/2-desk">
                        <text-input
                            v-model="form.street_number"
                            :error="form.errors.first('street_number')"
                            :label="trans('customer.street_number')"
                            name="street_number"
                            class="u-full-width"
                            required
                        />
                    </div>
                </div>
                <div class="layout | u-margin-bottom-narrow">
                    <div class="layout__item u-1/2-desk">
                        <div class="layout">
                            <div class="layout__item u-1/3-desk">
                                <text-input
                                    v-model="form.zip_code"
                                    :error="form.errors.first('zip_code')"
                                    :label="trans('customer.zip_code')"
                                    name="zip_code"
                                    class="u-full-width"
                                    required
                                />
                            </div>
                            <!---->
                            <div class="layout__item u-2/3-desk">
                                <text-input
                                    v-model="form.city"
                                    :error="form.errors.first('city')"
                                    :label="trans('customer.city')"
                                    name="city"
                                    class="u-full-width"
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <!---->
                    <div class="layout__item u-1/2-desk">
                        <single-select
                            v-model="form.country_code"
                            :error="form.errors.first('country_code')"
                            :label="trans('customer.country_code')"
                            :options="countryValues"
                            optionLabel="countryName"
                            optionValue="countryCode"
                            name="country_code"
                            class="u-full-width"
                            required
                        />
                    </div>
                </div>
                <div v-if="canGiveWhitelabelAccess" class="layout | u-margin-bottom-narrow">
                    <div class="layout__item u-1/2-desk">
                        <checkbox
                            v-model="form.create_user"
                            :error="form.errors.first('create_user')"
                            :label="trans('customer.create_user')"
                            name="create_user"
                            class="u-margin-bottom-narrow"
                        />
                    </div>
                </div>
                <nav>
                    <button class="btn btn--ghost | u-margin-bottom-narrow" type="submit" dusk="store-customer-button">
                        {{ trans('action.save') }}
                    </button>
                </nav>
            </form>
        </div>
    </div>
</template>

<script>
import customerMixin from '../mixins/customer.js';

export default {
    mixins: [customerMixin],
    props: {
        form: {
            type: Object,
            required: true
        },
        countries: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        /**
         * Return the countries with a label and value.
         *
         * @return {array}
         */
        countryValues() {
            return Object.entries(this.countries).map(country => ({
                countryCode: country[0],
                countryName: country[1]
            }));
        }
    },
    methods: {
        /**
         * Submit the create user form.
         */
        createUser() {
            this.$emit('submit', this.form);
        }
    }
};
</script>
